import React, { useRef, useState } from 'react';
import { CustomTooltip } from '@cian/ui-kit';

import * as s from './RulesItemWithTooltip.css';
import { IconFunctionalInformationCircle16 } from '../../../../Icons';

interface IRulesItemWithTooltip {
  title: string;
  count: number;
  description: string;
}

/**
 * Компонент элемента списка правил расчета
 */
export const RulesItemWithTooltip = ({ title, count, description }: IRulesItemWithTooltip) => {
  const [isOpened, setIsOpened] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  return (
    <>
      <span>
        {title}
        <span
          ref={ref}
          className={s['icon-wrapper']}
          onMouseEnter={() => setIsOpened(true)}
          onMouseLeave={() => setIsOpened(false)}
        >
          <IconFunctionalInformationCircle16 />
          <span className={s['icon-bg']} />
        </span>
      </span>

      <span>+{count}</span>

      <CustomTooltip
        anchorRef={ref}
        content={description}
        flip
        maxWidth={190}
        open={isOpened}
        placement="bottom-start"
        portal
        preventOverflow
        size="S"
        onClose={() => {}}
        theme={'white'}
      />
    </>
  );
};
